

//const urlBase = "http://200.21.4.66:8070/ehrest/index.php/EHFact2/";
const urlBase = "http://ramajudicialdelhuila.gov.co/PortalREST/index.php/RamaPortal/";


export const getProcesosUrl = `${urlBase}getProcesos`;
export const getProcesosCodUrl = `${urlBase}getProcesosCod`;

export const getLoginUrl = `${urlBase}getLogin`;
export const getCodProcesoUrl = `${urlBase}getCodProceso`;

export const getNombrePersonaUrl = `${urlBase}getNombrePersona`;
export const getDescripcionInstanciaUrl = `${urlBase}getDescripcionInstancia`;
export const getDescripcionAccionUrl = `${urlBase}getDescripcionAccion`;
export const getDescripcionDescriptorUrl = `${urlBase}getDescripcionDescriptor`;
export const getDescripcionRestrictorUrl = `${urlBase}getDescripcionRestrictor`;
export const getDescripcionDecisionUrl = `${urlBase}getDescripcionDecision`;
export const postProvidenciaUrl = `${urlBase}postProvidencia`;
export const postDeleteProcesoUrl = `${urlBase}postDeleteProceso`;


export const getCustomersUrl = `${urlBase}getCustomers`;
export const getCtaUrl = `${urlBase}getCta`;
export const postTerceroUrl = `${urlBase}postTercero`;
export const postAddCtaToTerceroUrl = `${urlBase}postAddCtaToTercero`;
export const getCtasTerceroUrl = `${urlBase}getCtasTercero`;
export const getContadorDetalleUrl = `${urlBase}getContadorDetalle`;
export const getContadorDetalleMesUrl = `${urlBase}getContadorDetalleMes`;
export const getContadorDetalleDiaUrl = `${urlBase}getContadorDetalleDia`;
export const postRemoveCtaTerceroUrl = `${urlBase}postRemoveCtaTercero`;
export const postTerceroPassUdpUrl = `${urlBase}postTerceroPassUdp`;
export const postRecuperarPasswordUrl = `${urlBase}postRecuperarPassword`;
export const postCuentaDetalleLimpiarUrl = `${urlBase}postCuentaDetalleLimpiar`;

export const usuarioPassUdpUrl = "http://contactc.com.co/Ctc/index.php/ContacTc/usuarioPassUdp";




